// @ts-ignore (peer dependency)
export { appWithTranslation } from 'next-i18next'
// @ts-ignore (peer dependency)
export { serverSideTranslations } from 'next-i18next/serverSideTranslations'
